export const RAG_LOADING_MESSAGES: string[] = [
  "Got it - interpreting your question…",
  "Searching trusted content and preparing your answer…",
  "Thanks for your patience - nearly there…",
];
